import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { defineConfig , loadEnv} from 'vite'
import { useAuthStore } from '@/stores/authStore'
import { redirectToClientLogin } from '@/auth/authRedirect'

import SidebarLayout from '@/layouts/SidebarLayout.vue'
import EmptyLayout from '@/layouts/EmptyLayout.vue'

import { loginRoute } from './auth/loginRoute'

import { inventoryRoute } from './temp/inventoryRoute'
import { inventoryRoute2 } from './temp/lib2Route'

import { blogRoute } from './blog/blogRoute'
import { userRoute as userRoute } from './auth/userRoute'
import { MenuDesignRoute  } from './menu/menuDesignRoute'
import { ReportDesignRoute } from './report/reportDesignRoute'
import { AdRoute  } from './temp/ad'
import { DemoRoute  } from './temp/demo'
import { deleteRoute  } from './auth/delete'
import { privacyRoute  } from './auth/privacy'
import { termsOfServiceRoute  } from './auth/termOfService'

import { menuRoute } from './menu/menuRoute'
import { menuOrderRoute } from './menu/menuOrderRoute'
import { TablePostRoute } from './temp/tablePostRoute'
import { paymentRoute } from './temp/payment'
import { paymentSuccessRoute } from './temp/payments'
import { orderManagementRoute } from './order/orderManagementRoute'
import { merchantOrderRoute } from './order/merchantOrderRoute'
import { bookingRoute } from './booking/bookingRoute'
import { bookingOrderRoute } from './booking/bookingRoute2'
import { reservationRoute } from './booking/bookingRoute3'
import { bookingActionRoute } from './booking/orderConfirm'
import { r2Route } from './r2/r2'
import { EcpayPaymentRoute } from './report/ecpayRoute'

import { ROUTES } from '@myorg/type-lib'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const IS_APP_BUILD = import.meta.env.VITE_BUILD_TARGET === 'app';

const routes: Array<RouteRecordRaw> = [
  // 🔐 不要 Sidebar 的頁面
  {
    path: ROUTES.HOME,
    component: EmptyLayout,
    children: [
      { 
        path: '', 
        redirect: (to) => {
          const authStore = useAuthStore()
          if (authStore.isLoggedIn) {
            return { path: ROUTES.USER.PATH }
          }
          redirectToClientLogin(to.fullPath)
          return { name: ROUTES.LOGIN.NAME }
        } 
      },
      // {
      //   path: ROUTES.LOGIN.PATH,
      //   component: Login,
      // },
      bookingActionRoute,
      bookingOrderRoute,
      loginRoute,
      menuOrderRoute,
      paymentRoute,
      paymentSuccessRoute,
      ...(!IS_APP_BUILD ? [AdRoute, DemoRoute] : []),
      deleteRoute,
      privacyRoute,
      termsOfServiceRoute,
    ],
  },
  {
    path: ROUTES.HOME,
    component: SidebarLayout,
    meta: { requiresAuth: true },
    children: [
      { 
        path: '', 
        redirect: (to) => {
          const authStore = useAuthStore()
          if (authStore.isLoggedIn) {
            return { path: ROUTES.USER.PATH }
          }
          redirectToClientLogin(to.fullPath)
          return { name: ROUTES.LOGIN.NAME }
        } 
      },
      // { path: ROUTES.LOGIN.PATH, component: Login },

      // { path: ROUTES.USER.PATH, component: UserPage },
      // BlogPostRoute,
      // { 
      //   name: ROUTES.POST_DETAIL.NAME,
      //   path: ROUTES.POST_DETAIL.PATH, 
      //   component: PostDetail, props: true 
      // },
      r2Route,
      reservationRoute,
      bookingRoute,
      userRoute,
      blogRoute,
      inventoryRoute,
      inventoryRoute2,
      MenuDesignRoute,
      ReportDesignRoute,
      EcpayPaymentRoute,
      // menuRoute,
      // menuOrderRoute,
      TablePostRoute,
      orderManagementRoute,
      merchantOrderRoute,
    ],
  },
]

// const base =
//   import.meta.env.VITE_APP_HOME_PATH ?? '/'

const router = createRouter({
  history: createWebHistory(),
  // history: createWebHistory(base),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始終捲動到頂部
    return { top: 0 }
  },
})

router.beforeEach((to) => {
  if (!to.matched.some(record => record.meta.requiresAuth)) {
    return true
  }

  const authStore = useAuthStore()
  if (authStore.isLoggedIn) {
    return true
  }

  redirectToClientLogin(to.fullPath)
  return false
})

export default router
